import React from 'react';
import PropTypes from 'prop-types';

import ItemLoading from './ItemLoading';

const renderItem = (item, index) => (
    <li
        key={index}
        className="loading"
    >
        <ItemLoading />
    </li>
);

const Placeholder = ({ repeat }) => (
    <ul>
        {Array(repeat).fill(0).map(renderItem)}
    </ul>
);

Placeholder.propTypes = {
    repeat: PropTypes.number.isRequired
};

export default Placeholder;
